import { useMutation } from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {links} from "../../../utils/links";
import {storeJWT} from "../../../utils/storageService";

interface AuthCredentials {
    username: string;
    password: string;
}

const useLogin = () => {

    const navigate = useNavigate();

    return useMutation({
        mutationKey: ['token'],
        mutationFn: (auth: AuthCredentials) => axios
            .post<String>(links.token, {}, {auth})
            .then((res) => res.data),
        onSuccess: (jwt) => {
            storeJWT(jwt.toString())
            navigate("/");
        }
    })
}

export default useLogin;